import errors from './errors';
import localstorage from './localstorage';

export default {
  errors,
  localstorage,
  addFirstElement(items, text = 'Seleccionar') {
    items.unshift({
      text,
      value: '',
    });
    return items;
  }
};
